
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Interaction/ModeSwitch.html",
      function () {
        return require("private-next-pages/Interaction/ModeSwitch.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Interaction/ModeSwitch.html"])
      });
    }
  